<div>
    <div class="row">
        <div class="col col-1">
            <p><b>Uitgekeerd dividend</b></p>
        </div>
        <div class="col-2">
        </div>
        <div class="col-4">
        </div>
    </div>
</div>
<form [formGroup]="dividendFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Datum dividenduitkering</p>
            </div>
            <div class="col-2">
                <snelstart-ui-date-form-control [disabledControl]="true"
                                                class="custom-input-150"
                                                formControlName="datumBeschikbaarstelling"
                                                id="datumBeschikbaarstelling"
                                                label=""
                >
                </snelstart-ui-date-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>
<form [formGroup]="dividendSpecFg">
    <ng-container formGroupName="belastNormaalTarief">
        <div *ngIf="dividendSpecFg.get('belastNormaalTarief.bedragBelastNormaalTarief')?.value > 0">
            <div class="row">
                <div class="col col-1">
                    <p>Dividend met inhouding regulier tarief</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedragBelastNormaalTarief"
                                                      id="bedragBelastNormaalTarief"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
                <div class="col-4"></div>
            </div>
        </div>
    </ng-container>
    <ng-container formGroupName="inhoudingsVrijstelling">
        <div *ngIf="dividendSpecFg.get('inhoudingsVrijstelling.bedragInhoudingsvrijstelling')?.value > 0">
            <div class="row">
                <div class="col col-1">
                    <p>Dividend met inhoudingsvrijstelling</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedragInhoudingsvrijstelling"
                                                      id="bedragInhoudingsvrijstelling"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
                <div class="col-4"></div>
            </div>
        </div>
    </ng-container>
    <ng-container formGroupName="belastVerdragsTarief">
        <div *ngIf="dividendSpecFg.get('belastVerdragsTarief.bedragMetVerdragstoepassing')?.value > 0">
            <div class="row">
                <div class="col col-1">
                    <p>Dividend met inhouding verdragstarief</p>
                </div>
                <div class="col-2">
                    <snelstart-ui-number-form-control [disabledControl]="true"
                                                      [showAllDecimals]="false"
                                                      align="right"
                                                      class="custom-input-150"
                                                      formControlName="bedragMetVerdragstoepassing"
                                                      id="bedragMetVerdragstoepassing"
                                                      prefix="€"
                    >
                    </snelstart-ui-number-form-control>
                </div>
                <div class="col-4"></div>
                <div class="col-4"></div>
            </div>
        </div>
    </ng-container>
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Totaal</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [disabledControl]="true"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragDividenduitkering"
                                                  id="bedragDividenduitkering2"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>
<div *ngIf="this.aangifte.opgaafDb !== undefined" class="pt-3">
    <div class="row">
        <div class="col col-1">
            <p><b>Opgaaf dividendbelasting</b></p>
        </div>
        <div class="col-2">
        </div>
        <div class="col-4"></div>
    </div>
</div>
<form [formGroup]="opgaafFg">
    <div *ngIf="this.aangifte.opgaafDb !== undefined" class="pt-3">
        <div class="row">
            <div class="col col-1">
                <p>Dividend aan buitenlandse aandeelhouders zonder inhouding</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [disabledControl]="true"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragDividenduitkering"
                                                  id="bedragDividenduitkering3"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>


<div class="pt-3">
    <div class="row">
        <div class="col col-1">
            <p><b>Dividendbelasting</b></p>
        </div>
        <div class="col-2">
        </div>
        <div class="col-4">
        </div>
    </div>
</div>

<form [formGroup]="dividendFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Totaal uitgekeerd dividend</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [disabledControl]="true"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="bedragDividenduitkering"
                                                  id="bedragDividenduitkering"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>
<form [formGroup]="aangifteFg">
    <div>
        <div class="row">
            <div class="col col-1">
                <p>Af te dragen dividendbelasting (15%)</p>
            </div>
            <div class="col-2">
                <snelstart-ui-number-form-control [disabledControl]="true"
                                                  [showAllDecimals]="false"
                                                  align="right"
                                                  class="custom-input-150"
                                                  formControlName="verschuldigdeBelasting"
                                                  id="verschuldigdeBelasting"
                                                  prefix="€"
                >
                </snelstart-ui-number-form-control>
            </div>
            <div class="col-4"></div>
        </div>
    </div>
</form>
